import { useQuery } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { TicketFieldsFragment } from 'components/Events/gql/Events.fragments';

// Query to get event data for EditEventV2
// Includes tickets, account_id, and other essential fields
const GET_EVENT_FOR_EDIT = gql`
  query GetEventForEdit($input: GetEventInput!) {
    getEvent(input: $input) {
      id
      name
      track_id
      account_id
      start_date
      end_date
      eventDates
      isMultiDay
      listDates
      status
      sale_start
      sale_end
      on_sale_time
      off_sale_time
      admin_times {
        id
        event_date
        gate_time
        start_time
      }
      # Details tab fields
      reserved_seats
      sales_windows
      event_types
      capacity
      show_pitpay
      show_tickethoss
      admin_scan_out
      admin_website_url
      admin_schedule_url
      code
      code_date
      code_time
      divisions {
        id
        name
      }
      series_ids
      # Media & Marketing tab fields
      image
      image_id
      logo
      logo_id
      promo_image
      promo_image_id
      facebook_image
      facebook_image_id
      armband_image
      armband_logo_id
      facebook
      instagram
      twitter
      url
      info_video_url
      about
      schedule_details
      schedule_detail_url
      schedule_detail_image
      schedule_detail_pdf
      schedule_detail_image_id
      faqs {
        id
        question
        answer
        order
      }
      # Promoter tab fields
      promoter_name
      promoter_organization
      promoter_email
      promoter_phone
      promoter_website
      # POS & Account tab fields
      pos
      pos_settings {
        ticket_delivery
        receipt_delivery
        payment
        calculator
      }
      marketing_fee
      international_fee
      hide_fee
      admin_tickets {
        ...ticketFields
      }
      admin_multiday_tickets {
        ...ticketFields
      }
      admin_other_tickets {
        ...ticketFields
      }
      admin_bundle_tickets {
        ...ticketFields
        associated_tickets {
          id
          name
          quantity
        }
      }
      admin_registration_tickets {
        ...ticketFields
        admin_pages {
          id
          pdf_id
          pdf_url
          name
          form_id
          waivers
          order
          video_url
        }
      }
      admin_infos {
        id
        logo
        logo_id
        link
        text
        info {
          id
          name
        }
        order
        video_url
        image_id
        image_url
        pdf_id
        pdf_url
        type
      }
      notes {
        id
        title
        note
        type
        image
        image_id
        created_at
        created_by {
          id
          formatted_name
        }
      }
      lap_sponsorships {
        id
        name
        num_laps
        price
        order
        payout_1
        payout_1_label
        payout_2
        payout_2_label
        payout_3
        payout_3_label
      }
      waivers {
        id
        name
      }
      track {
        id
        name
        timezone
        logo
        infos {
          id
          logo
          logo_id
          link
          text
          info {
            id
            name
          }
          order
          video_url
          image_id
          image_url
          pdf_id
          pdf_url
        }
      }
      series {
        id
        name
        logo
        infos {
          id
          logo
          logo_id
          link
          text
          info {
            id
            name
          }
          order
          video_url
          image_id
          image_url
          pdf_id
          pdf_url
        }
      }
    }
  }
  ${TicketFieldsFragment}
`;

export function useGetEventForEdit(eventId) {
  const id = eventId ? Number(eventId) : null;

  const { data, loading, error, refetch } = useQuery(GET_EVENT_FOR_EDIT, {
    variables: { input: { id } },
    skip: !id,
    fetchPolicy: 'cache-and-network',
  });

  return {
    event: data?.getEvent || null,
    loading,
    error,
    refetch,
  };
}
